module.exports = __webpack_public_path__ + "static/media/talent-benefit-easy.36a6a796.png";